// "This weekend, for you" (features 10/16): each Thursday (LA time) a fresh set of five picks for Friday to Sunday,
// weighted to one-offs that only happen that weekend, in taste order. No server change: the browse function's For you
// row, asked for the weekend's dates (it ranks by taste inside them), trimmed here. The set is kept per weekend and per
// person on this device, so it stays the same five from Thursday to Sunday. The clock is lib/flags.ts qaNow(), so the
// QA panel's "pretend today is" shows any day's answer.
import { browse, type Card } from './browse'
import { ownerNow } from './owner'
import { qaNow, qaState } from './flags'
import { pickFive, weekendWindow, type WeekendWindow } from './weekendCore'
export { isOneOff, pickFive, rangeLabel, weekendWindow, WEEKEND_SIZE, type WeekendWindow } from './weekendCore'

const KEY = 'mg_weekend_set'

type Kept = { uid: string | null; fri: string; cards: Card[]; at: number }
function readKept(): Kept | null { try { return JSON.parse(localStorage.getItem(KEY) ?? 'null') as Kept | null } catch { return null } }
function writeKept(k: Kept) { try { localStorage.setItem(KEY, JSON.stringify(k)) } catch { /* shown this time only */ } }

/** The kept five for this weekend, if this person already has them (no network). */
export function keptFive(w: WeekendWindow): Card[] | null {
  if (!w.open || qaState().on) return null
  const k = readKept()
  if (!(k && k.fri === w.fri && k.uid === ownerNow())) return null
  // Saturday and Sunday: an event of the kept set that is already over drops out
  const now = Date.now()
  return k.cards.filter((c) => { const e = c.item.end_at ?? c.item.start_at; return c.item.kind !== 'event' || !e || new Date(e).getTime() > now })
}

/** This weekend's five: the kept set, or a fresh one from the browse function (kept until Sunday ends). */
export async function loadFive(w: Extract<WeekendWindow, { open: true }>): Promise<Card[]> {
  const kept = keptFive(w)
  if (kept) return kept
  const uid = ownerNow()
  // 15, not more: browse logs every card it returns as a For you impression (ranker training data)
  const res = await browse({ row: 'for_you', from: w.from, to: w.to, limit: 15 })
  const five = pickFive(res.items ?? [], w.from, w.to)
  // a QA "pretend today is" answer is never kept as the real set
  if (!qaState().on && five.length) writeKept({ uid, fri: w.fri, cards: five, at: Date.now() })
  return five
}

export const currentWindow = () => weekendWindow(qaNow())

